export const actionTypes = {
	SET_LOCALSTATE: 'SET_LOCALSTATE',
	ADD_CONTACT: 'ADD_CONTACT',
	REMOVE_CONTACT: 'REMOVE_CONTACT',
	BLOCK_ADDRESS: 'BLOCK_ADDRESS',
	UNBLOCK_ADDRESS: 'UNBLOCK_ADDRESS',
	HIDE_ADDRESS: 'HIDE_ADDRESS',
	UNHIDE_ADDRESS: 'UNHIDE_ADDRESS',
};
